<template>
  <section class="page-section">
    <!-- filter -->
    <div class="filter-region">
      <div class="filter-form">
        <el-form
          size="small"
          :inline="true"
          :model="filterForm"
          ref="filterForm"
        >
          <el-form-item label="员工姓名：" prop="name">
            <el-input v-model="filterForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="状态：" prop="status">
            <el-select v-model="filterForm.status" placeholder="请选择">
              <el-option label="关闭" value="0"></el-option>
              <el-option label="启用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色：" prop="role">
            <el-select v-model="filterForm.role" placeholder="请选择">
              <el-option
                v-for="(item, index) in filterForm.roleList"
                :label="item.name"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="filter-btn">
        <el-button-group class="btn-group">
          <el-button
            plain
            class="btn-reset"
            icon="el-icon-refresh"
            @click="filterFormReset('filterForm')"
          ></el-button>
          <el-button
            type="primary"
            class="btn-search"
            @click="filterFormSubmit('filterForm')"
            :loading="tableLoading"
            >查询</el-button
          >
        </el-button-group>
      </div>
    </div>
    <el-button
      class="btn-add-block"
      type="primary"
      @click="pageNavigateToPermissionStaffAdd"
      >新增员工</el-button
    >

    <!-- table -->
    <div class="table-region last-text-align-right" v-loading="tableLoading">
      <el-table size="small" :data="tableData">
        <el-table-column label="员工姓名">
          <template slot-scope="scope">
            <p>{{ scope.row.name }}</p>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <p>{{ scope.row.mobile }}</p>
          </template>
        </el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope">
            <p v-for="(item, index) in scope.row.role" :key="index">
              {{ item }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :inactive-value="close"
              :active-value="open"
              active-color="#43B034"
              inactive-color="#D4D4DC"
              @change="handleSwitch(scope)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="right">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="pageNavigateToPermissionStaffEdit(scope)"
              >编辑</el-button
            >

            <el-popover
              placement="left"
              width="160"
              v-model="scope.row.deleteVisible"
              popper-class="confirm-popover"
            >
              <p>确定删除？</p>
              <div>
                <el-button
                  size="small"
                  type="default"
                  plain
                  @click="scope.row.deleteVisible = false"
                  >取消</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  @click="handleDelete(scope)"
                  >确定</el-button
                >
              </div>
              <el-button slot="reference" size="small" type="text"
                >删除</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <div class="table-footer" v-if="page.total > 0">
        <div class="selection-operate"></div>

        <div class="pagination-wrap">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            :pager-count="5"
            :current-page="page.current"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  permissionRoleList,
  staffList,
  staffStatusUpdate,
} from "../../../common/api";

export default {
  data() {
    return {
      filterForm: {
        name: "", // 员工名字
        status: "", // 状态
        role: "", // 角色id
        roleList: [], // 角色列表
      },
      tableLoading: false,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0,
      },

      open: 1, // 启用
      close: 0, // 关闭
    };
  },
  methods: {
    /**
     * [getList description] 获取角色列表
     * @return {[type]}          [description]
     */
    getRole: function () {
      let param = {
        pageNo: 1,
        pageSize: 1000,
      };

      permissionRoleList(param)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.filterForm.roleList = data.records || [];
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [getList description] 获取列表
     * @return {[type]}          [description]
     */
    getList: function () {
      this.tableLoading = true;

      let param = {
        name: this.filterForm.name,
        status: this.filterForm.status,
        role: this.filterForm.role,
        pageNo: this.page.current,
        pageSize: this.page.size,
      };

      staffList(param)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.tableData = data.records || [];
            this.page.total = data.total;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.tableLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [pageNavigateToPermissionStaffAdd description] 新增员工
     * @return {[type]}     [description]
     */
    pageNavigateToPermissionStaffAdd: function () {
      this.$router.push("/permission/staff/add");
    },
    /**
     * [pageNavigateToPermissionStaffEdit description] 编辑详情
     * @param  {[Object]} scope [description] 当前操作列的对象
     * @return {[type]}     [description]
     */
    pageNavigateToPermissionStaffEdit: function (scope) {
      this.$router.push({
        path: "/permission/staff/add",
        query: { id: scope.row.id },
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [handleDelete description] 删除员工
     * @param  {[Object]} scope [description] 当前操作行
     * @return {[type]}          [description]
     */
    handleDelete: function (scope) {
      let param = {
        id: scope.row.id,
        status: -1,
      };

      this.updateStatus(param);
    },
    /**
     * [handleSwitch description] 启用和禁用
     * @param  {[Object]} scope [description] 当前操作行
     * @return {[type]}          [description]
     */
    handleSwitch: function (scope) {
      let param = {
        id: scope.row.id,
        status: scope.row.status,
      };

      this.updateStatus(param);
    },
    updateStatus: function (param) {
      staffStatusUpdate(param)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.$message.success("操作成功");
            this.getList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.tableLoading = false;
          this.$message.error("服务器异常");
        });
    },
  },
  mounted() {
    if (this.$route.query.roleId) {
      this.filterForm.role = Number(this.$route.query.roleId);
    }

    this.getRole();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.filter-region {
  flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;

  .filter-form {
    flex: 1;
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        & + .el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}
</style>
